import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContactMessage } from '../models/contactMessage.model';
import { DatePipe } from '@angular/common'
import * as firebase from 'firebase';


@Injectable({
    providedIn: 'root'
})

export class ContactMessageService {

    constructor(private httpClient: HttpClient,
                private datePipe: DatePipe) { }

    saveContactMessage(newContactMessage: ContactMessage) {
        let latest_date = this.datePipe.transform(new Date(), 'yyyy|MM|dd - HH:mm - ss SSS');
        firebase.database().ref('/contactMessage').child(latest_date).set(newContactMessage);
    }
}